import Axios from "axios";
export const getPropertiesFNA = isMx => {
  if (isMx) return new Promise(resolve => resolve(false));
  const url = "https://strapi-v2.habi.co/getPageByQuery?country=CO&project=co_brokers&page=co_brokers_properties_fna";
  return Axios({
    url
  });
};